import toggleAll from './toggle-all.reducer';
import setSearch from './set-search.reducer';
import setTab from './set-tab.reducer';
import toggleGroup from './toggle-group.reducer';
import toggleMember from './toggle-member.reducer';
import setDefaults from './set-default.reducer';
import setMemberRoleFilter from './set-member-role-filter.reducer';
import toggleTotal from './toggle-total.reducer';

export default {
  toggleAll,
  setSearch,
  setTab,
  toggleGroup,
  toggleMember,
  setDefaults,
  setMemberRoleFilter,
  toggleTotal,
};
